import { createAction } from "redux-actions";
import { NotificationsConstants } from "../constants/notifications.constants";

export const openNotificationsPopover = createAction(
    NotificationsConstants.OPEN_NOTIFICATIONS_POPOVER
);
export const closeNotificationsPopover = createAction(
    NotificationsConstants.CLOSE_NOTIFICATIONS_POPOVER
);

export const fetchNotifications = createAction(
    NotificationsConstants.FETCH_NOTIFICATIONS
);
export const fetchNotificationsSuccess = createAction(
    NotificationsConstants.FETCH_NOTIFICATIONS_SUCCESS
);
export const fetchNotificationsFailure = createAction(
    NotificationsConstants.FETCH_NOTIFICATIONS_FAILURE
);

export const setOpenedAt = createAction(NotificationsConstants.SET_OPENED_AT);
export const setOpenedAtSuccess = createAction(
    NotificationsConstants.SET_OPENED_AT_SUCCESS
);
export const setOpenedAtFailure = createAction(
    NotificationsConstants.SET_OPENED_AT_FAILURE
);

export const setViewedAt = createAction(NotificationsConstants.SET_VIEWED_AT);
export const setViewedAtSuccess = createAction(
    NotificationsConstants.SET_VIEWED_AT_SUCCESS
);
export const setViewedAtFailure = createAction(
    NotificationsConstants.SET_VIEWED_AT_FAILURE
);



// WEBPACK FOOTER //
// ./src/actions/notifications.actions.js